/* Tapzo Store — buy box con packs y variantes sobre el formulario real de Shopify */
(function () {
  'use strict';

  function initBuyBox(root) {
    var form = root.querySelector('form[data-tzs-form]');
    if (!form) return;
    var idInput = form.querySelector('input[name="id"]');
    var qtyInput = form.querySelector('input[name="quantity"]');
    var bundles = root.querySelectorAll('.tzs-bundle');
    var swatches = root.querySelectorAll('.tzs-swatch');
    var priceNowEls = root.querySelectorAll('[data-tzs-price-now]');
    var priceWasEls = root.querySelectorAll('[data-tzs-price-was]');

    function currentSwatchVariant() {
      var active = root.querySelector('.tzs-swatch.active');
      return active ? active.dataset.variantId : null;
    }

    function applyState() {
      var bundle = root.querySelector('.tzs-bundle.active');
      if (!bundle) return;
      var overrideVariant = bundle.dataset.variantId;
      var qty = bundle.dataset.qty || '1';
      var swatchVariant = currentSwatchVariant();

      if (overrideVariant) {
        idInput.value = overrideVariant;
      } else if (swatchVariant) {
        idInput.value = swatchVariant;
      }
      qtyInput.value = qty;

      /* Las variantes de color solo aplican cuando el pack no fuerza otro producto */
      swatches.forEach(function (s) {
        s.toggleAttribute('disabled', !!overrideVariant);
      });

      priceNowEls.forEach(function (el) { el.textContent = bundle.dataset.price || ''; });
      priceWasEls.forEach(function (el) {
        var was = bundle.dataset.compare || '';
        el.textContent = was;
        el.style.display = was ? '' : 'none';
      });
    }

    bundles.forEach(function (b) {
      b.addEventListener('click', function () {
        bundles.forEach(function (x) { x.classList.remove('active'); });
        b.classList.add('active');
        var input = b.querySelector('input[type="radio"]');
        if (input) input.checked = true;
        applyState();
      });
    });

    swatches.forEach(function (s) {
      s.addEventListener('click', function (ev) {
        ev.preventDefault();
        if (s.hasAttribute('disabled')) return;
        swatches.forEach(function (x) { x.classList.remove('active'); });
        s.classList.add('active');
        applyState();
      });
    });

    /* Galería */
    var thumbs = root.querySelectorAll('.tzs-thumbs button');
    var views = root.querySelectorAll('.tzs-gallery-main [data-view]');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        thumbs.forEach(function (x) { x.classList.remove('active'); });
        t.classList.add('active');
        views.forEach(function (v) {
          v.style.display = (v.dataset.view === t.dataset.view) ? '' : 'none';
        });
      });
    });

    /* Barra sticky móvil: visible cuando el buy box sale de pantalla */
    var sticky = document.querySelector('.tzs-sticky[data-for="' + (root.id || '') + '"]');
    if (sticky && 'IntersectionObserver' in window) {
      var pinfo = root.querySelector('.tzs-pinfo');
      new IntersectionObserver(function (entries) {
        sticky.classList.toggle('visible', !entries[0].isIntersecting);
      }, { threshold: 0 }).observe(pinfo || root);
      var stickyBtn = sticky.querySelector('[data-tzs-submit]');
      if (stickyBtn) {
        stickyBtn.addEventListener('click', function () {
          var btn = form.querySelector('button[type="submit"]');
          if (btn) btn.click(); else form.submit();
        });
      }
    }

    applyState();
  }

  function init() {
    document.querySelectorAll('[data-tzs-buybox]').forEach(initBuyBox);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  /* Re-init al recargar secciones en el editor de temas */
  document.addEventListener('shopify:section:load', init);
})();
